export const IntervalLengthConstants = {
  Day: 1,
  Week: 7,
  Month: 30,
  Quarter: 90,
  Year: 365,
};
